import { supabase } from './supabaseClient';
import { toast } from 'react-toastify';
import { FRONTEND_BASE_URL } from '../constants';

const signup = async (username, email, password) => {
    try {
        const {data, error} = await supabase.auth.signUp({
            email: email,
            password: password,
            options: {
                data: { full_name: username },
                redirectTo: `${FRONTEND_BASE_URL}/dashboard/generate`,
            },
        });
        if (error) {
            if (error.code === "user_already_exists") {
                toast.error("User already exists, please sign in");
            } else {
                toast.error("Error signing up, please try again");
            }
            return { data: null, error };
        }
        toast.success("Sign Up Successful!");
        return { data, error: null };
    } catch (error) {
        toast.error("Error signing up, please try again");
        return { data: null, error };
    }
};

const signinWithGoogle = async (redirectUrl) => {
    try {
        const { data, error } = await supabase.auth.signInWithOAuth({
            provider: 'google',
            options: {
                redirectTo: `${FRONTEND_BASE_URL}/dashboard/generate`,
            }
        });
        if (error) {
            toast.error("Error signing in, please try again");
            return { data: null, error };
        }
        // Don't show success toast here since OAuth redirect will reload the page
        return { data, error: null };
    } catch (error) {
        toast.error("Error, please try again");
        return { data: null, error };
    }
};

const signinWithEmail = async (email, password) => {
    try {
        const {data, error} = await supabase.auth.signInWithPassword({
            email: email,
            password: password,
            options: {
                redirectTo: `${FRONTEND_BASE_URL}/dashboard/generate`,
            }
        });
        if (error) {
            toast.error(error.message);
            return { data: null, error };
        }
        toast.success("Sign in successful!");
        return { data, error: null };
    } catch (error) {
        toast.error("Error signing in, please try again");
        return { data: null, error };
    }
};

const sendPasswordResetEmail = async (email) => {
    try {
        const {data, error} = await supabase.auth.resetPasswordForEmail(email, {
            redirectTo: `${FRONTEND_BASE_URL}/reset`,
        });
        if (error) {
            toast.error("Error resetting password, please try again");
            return { data: null, error };
        }
        toast.success("Password reset email sent, please check your inbox");
        return { data, error: null };
    } catch (error) {
        console.log(error)
        toast.error("Error resetting password, please try again");
        return { data: null, error };
    }
};

const resetPassword = async (newPassword) => {
    try {
        const { data, error } = await supabase.auth.updateUser({ password: newPassword })
        if (error) {
            toast.error("Error resetting password, please try again");
            return { data: null, error };
        }
        toast.success("Password reset successful, please sign in");
        return { data, error: null };
    } catch (error) {
        toast.error("Error resetting password, please try again");
        return { data: null, error };
    }
};

export { signup, signinWithGoogle, signinWithEmail, sendPasswordResetEmail, resetPassword };
